import { usePageInfo } from '../config/queries'
import { useActionable } from '../hooks/useActionable'
import { useHasSidebar } from '../hooks/useHasSidebar'
import EntityMenu, { MenuItem } from './EntityMenu'
import { cn } from '@/lib/utils'

const Subheader = ({
  className,
  menuItems,
}: {
  className?: string
  menuItems: MenuItem[]
}) => {
  const {
    data: { user },
  } = usePageInfo()
  const { currentAction } = useActionable(user)
  const hasSidebar = useHasSidebar()

  return (
    <div
      className={cn(
        'border-b-2 sticky min-h-[40px] w-full z-40 bg-background',
        hasSidebar
          ? currentAction
            ? 'top-[31px]'
            : 'top-0'
          : currentAction
          ? 'top-[87px]'
          : 'top-[56px]',
        className,
      )}
    >
      <div
        className={cn(
          'group flex flex-1 min-w-0 w-full list-none items-center max-sm:justify-center space-x-0 max-sm:[&>li]:grow max-sm:flex max-sm:[&_a]:w-full',
          'root-width',
          hasSidebar && 'mx-0',
        )}
      >
        <EntityMenu menuItems={menuItems} placement='subheader' />
      </div>
    </div>
  )
}

export default Subheader
